import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Customer from '@/models/Customer'
import MultiChoiceCardOrder from '@/models/MultiChoiceCardOrder'

@Model()
export default class MultiChoiceCardOrderLine extends ApplicationRecord {
  static jsonapiType = 'multi_choice_card_order_lines'

  @Attr() id!: string
  @Attr() amount!: number
  @Attr() amountCents!: number
  @Attr() scheduledAt!: string | null
  @Attr() customerId!: string
  @Attr() multiChoiceCardOrderId!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string

  @BelongsTo() customer!: Customer
  @BelongsTo() multiChoiceCardOrder!: MultiChoiceCardOrder
}
